import React, {Component} from 'react';
import {Button, Form, Grid, Header, Icon, Popup,Segment,ButtonGroup,Image} from 'semantic-ui-react';
import {CollapsiblePanel, Toggle} from '../universal/collapsiblePanel';
import {DropzoneComponent} from 'react-dropzone-component';
import 'react-dropzone-component/styles/filepicker.css';
import 'dropzone/dist/min/dropzone.min.css';
import ReportContainer from "../../containers/report_container";
import {deleteImageFromReport} from "../../data/report_api";
import AddNewDataToReport from "./add_new_data";
import * as unavailable from "../../assets/photo_unavailable.jpg";


const uuidv1 = require('uuid/v1');
let _mounted = false;

class ItemsListView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            activeIndex: 0,
            attachments: [],
            coType: undefined,
            deleteCalled: false,
            itemName: undefined,
            checkInNotes: "",
            checkOutNotes: "",
            openItems:false,
            newItemAdded:false,
            showCoAdd:undefined,
            additionalCoNoteFlag:"Wear and Tear",
        };
    }

    componentWillMount() {
        this._mounted = true;
        // window.onscroll = (e) => {
        //     if(this._mounted){
        //         this.setState({showCoAdd:undefined});
        //     }
        // }
    };

    componentWillUnmount() {
        this._mounted = false;
    }

    removingFile = (file) => {
        let attachments = this.state.attachments;
        if (attachments.indexOf(file) !== -1) {
            attachments.splice(attachments.indexOf(file), 1);
        }
        return attachments;
    };
    removeItemImage = (r_i,g_i,i,file) =>{
        this.removingFileSpeech(file)
          if (file.id) {deleteImageFromReport(file.id).then((res) => {});}
            this.props.removeMediaFromReport(r_i,g_i,i,file)
        }

         removingFileSpeech = (file) => {
        let attachments = [...this.state.attachments]

        if (attachments.indexOf(file) !== -1) {
            attachments.splice(attachments.indexOf(file), 1);
        }
        this.setState({attachments:attachments})
    };

    useOverlayImage = (r_i,g_i,i_i,fileData) => {
  const url = fileData.file;
  const extension = url.split('.').pop().split('?')[0].toLowerCase();

  let mimeType = 'image/jpeg'; // default
  if (extension === 'png') mimeType = 'image/png';
  if (extension === 'jpg' || extension === 'jpeg') mimeType = 'image/jpeg';

  const filename = `${fileData.id}.${extension}`;
  const client_id = uuidv1();


    const dummyBlob = new Blob([""], { type: "image/png" });
    const dummyFile = new File([dummyBlob],filename, {
        type: "image/png",
    });
    dummyFile.dataURL = url
  let imageObj = {
    additionalImgId:fileData.id,
    id:client_id,
    file: dummyFile,
    image_path: url,
};
this.props.addNewMediaIntoReport(r_i, g_i, i_i, imageObj);

this.nextOverlayImage(1);
};

    updateItemDetails = (roomIndex, groupIndex, itemIndex, item) => {
        if (!item.action) {
            item['action'] = 'update';
        }
        item['name'] = this.state.itemName;
        this.setState({showEdit: undefined});
        this.props.updateItemInReport(roomIndex, groupIndex, itemIndex, item);
    };

    updateCheckInNotes = (roomIndex, groupIndex, itemIndex, item) => {
        if (!item.action) {
            item['action'] = 'update';
        }
        item['ci_notes'] = this.state.checkInNotes;
        this.props.updateItemInReport(roomIndex, groupIndex, itemIndex, item);
        this.setState({showEdit: undefined});
    };

    updateCheckOutNotes = (roomIndex, groupIndex, itemIndex, item, coType, additional, tenantCostCategory) => {
        if (!item.action) {
            item['action'] = 'update';
        }
        if(this.state.checkOutNotes){
                item['co_notes'] = this.state.checkOutNotes;
        }            
        if(coType){
                item['flag'] = coType;
            }
        if(item['co_notes'] === " "){
            item['flag'] = "None";
        }
        if(additional){
            const formData = new FormData(additional.target);
            const coNote = formData.get('co_desc_text');
            const flag = this.state.additionalCoNoteFlag;
            const category = this.state.additionalCoNoteTenantCostCategory;
            const addCoObject = {"flag": flag, "co_notes": coNote,"action":"create", "tenant_cost_category":category};
            if(Array.isArray(item['additional_co_notes'])) {
                item['additional_co_notes'].push(addCoObject);
            }
            else {
                item['additional_co_notes'] = [addCoObject];
            }
        }

        if (tenantCostCategory) {
            item["tenant_cost_category"] = tenantCostCategory
        }
        this.props.updateItemInReport(roomIndex, groupIndex, itemIndex, item);
        this.setState({showEdit: undefined,additionalCoNoteFlag:"Wear and Tear", additionalCoNoteTenantCostCategory:undefined});
    };

    nextOverlayImage = (stepAmount = 1) =>{
        const index = this.props.overlayImageList.findIndex(img => img.id === this.props.overlayImage.id);
        if (index !== -1 && (index + stepAmount < this.props.overlayImageList.length - 1)) {
            this.props.setSelectedOverlayImage(this.props.overlayImageList[index + stepAmount]);
        }
        else { this.props.setSelectedOverlayImage(this.props.overlayImageList[this.props.overlayImageList.length - 1]);}
    }

    previousOverlayImage = (stepAmount = 1) =>{
        const index = this.props.overlayImageList.findIndex(img => img.id === this.props.overlayImage.id);
        if (index !== -1 && (index - stepAmount > 0)) {
            this.props.setSelectedOverlayImage(this.props.overlayImageList[index - stepAmount]);
        } else {
            this.props.setSelectedOverlayImage(this.props.overlayImageList[0]);
        }
    }
    handleAdditionalCODelete = (roomIndex, groupIndex, itemIndex, item, removedIndex) => {
        let itemOnEdit = item;
        let additionCo = itemOnEdit['additional_co_notes'];
        if(additionCo && additionCo[removedIndex]['id']){
            itemOnEdit['additional_co_notes'][removedIndex]['action']= "delete";
            if(itemOnEdit['action'] !== 'create'){
                itemOnEdit['action'] = 'update';
            }
        }
        else{
            additionCo.splice(removedIndex, 1);
            itemOnEdit['additional_co_notes'] = additionCo;
        }
        this.props.updateItemInReport(roomIndex, groupIndex, itemIndex, itemOnEdit);
        this.setState({deleteCalled: !this.state.deleteCalled})
    };

    render() {
        const items = this.props.items;
        const checkoutNoteFlag = [
            {key: 1, text: "None (Show as Checkmark)", value: "None"},
            {key: 2, text: "Fair Wear and Tear", value: "Wear and Tear"},
            {key: 3, text: "Tenant Cost", value: "Tenant Cost"},
            {key: 4, text: "Landlord Information", value: "Landlord Info"},
            this.props.other_template && {key: 5, text: "Similar to CI", value: "Similar"},
        ];

        const tenantCostCategories = [
            { key: 4, text: "CLEANING", value: "CLEANING" },
            {key: 1, text: "DAMAGE", value: "DAMAGE"},
            { key: 3, text: "REDECORATION", value: "REDECORATION" },
            {key: 2, text: "GARDENING", value: "GARDENING"},
            { key: 5, text: "OTHER", value: "OTHER" },
        ];
        return (<div>
            <Header textAlign="left" className=" pad-top"><span className="format-underlined">Items</span> {<Icon name= {this.state.openItems ?"compress":"expand"} className="icon-button pull-right" color="grey" size="small" onClick={() => {this.setState({openItems:!this.state.openItems})}}/>}</Header>
            <CollapsiblePanel>
                {this.props.items ? items.map((item, i) => {
                    function preloadImages(dropzone) {
                        (item.images || []).forEach(function (i) {
                            const name = i.id;
                            let file = {url: i['image_path'], name: name, size: 1000000, id: name};
                            let imageUrl = i['image_path'];
                            if (i.image) {
                                file = i.image.file;
                                imageUrl = i.image.file.dataURL;
                            }

                            file['serverId'] = name;
                            file['accepted'] = true;
                            file['status'] = 'success';
                            file['upload'] = {
                                progress: 100,
                                total: 100000,
                                bytesSent: 100000
                            };
                            dropzone.files.push(file);

                            dropzone.emit("addedfile", file);
                            dropzone.emit("thumbnail", file, imageUrl);
                            dropzone.emit("complete", file);
                        });
                    }

                    let dropZone = null;
                    const componentConfig = {postUrl: 'no-url'};

                    let djsConfig = {autoProcessQueue: false, addRemoveLinks: true, acceptedFiles: "image/*"};
                    const eventHandlers = {
                        init: (dropzone) => {
                            dropZone = dropzone;
                            dropZone.autoDiscover = false;
                            preloadImages(dropzone);
                        },
                        addedfile: (file) => {
                            const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
                            if (isMobile) {
                                alert("You are using a mobile device, do not add images directly using the dropboxes as they can be lost this way. Please take and add photos with the live camera/image overlay feature or use your phone's camera app to ensure they are saved to your camera roll.");
                            }

                                                        const isHeic = file.type === "image/heic" || file.type === "image/heif" || file.name.toLowerCase().endsWith(".heic") || file.name.toLowerCase().endsWith(".heif");

                            if (isHeic) {
                                dropZone.removeFile(file);
                                alert(`HEIC images are not supported. Please upload JPG or PNG. You can google HEIC to JPG to find free online conversion services. Also please set your iPhone image file type to Best Compatibilty. Change iPhone Settings for Future Photos: Go to Settings > Camera > Formats and select "Most Compatible" to ensure new photos are saved directly as JPG, avoiding the need for conversion later.
Convert on iPhone Using the Files App: Open the Photos app, select the HEIC photo(s), tap Share, then Copy. Open the Files app, go to "On My iPhone," create a new folder, long-press in the folder, and tap Paste. The pasted image will be in JPG format.
Convert on iPhone Using Email: Send the HEIC photo to yourself via the Mail app. The attachment will be automatically converted to JPG upon download.
Convert on Mac Using the Photos App: Open the Photos app, select the HEIC photos, go to File > Export > Export [number] Photos, choose "JPEG" as the format, and select a save location.
Use Online Converters: Websites like HEIC.online, Canva, and Cloudinary allow users to drag and drop HEIC files to convert them to JPG instantly, with options to adjust quality and remove metadata.`  );

                                return; 
                            }
                            let imageObj = {
                                id: file.upload.uuid,
                                file: file,
                            };
                            if(file.upload.image_path) {
                                imageObj.image_path =  file.upload.image_path 
                            }
                            if(file.upload.additionalImgId) {
                                imageObj.additionalImgId =  file.upload.additionalImgId
                                const dummyBlob = new Blob([""], { type: "image/png" });
                                const dummyFile = new File([dummyBlob], `${file.upload.additionalImgId}.png`, {
                                    type: "image/png",
                                });
                        
                                imageObj.file = dummyFile;
                                if(file.upload.image_path) {
                                    imageObj.image_path =  file.upload.image_path 
                                    imageObj.file.dataURL =  file.upload.image_path 
                                }
                            }
                            this.props.addNewMediaIntoReport(this.props.roomIndex, this.props.groupIndex, i, imageObj);
                        },
                        removedfile: (file) => {
                            this.setState({attachments: this.removingFile(file)});
                            if (file.id) {
                                deleteImageFromReport(file.id).then((res) => {
                                });
                            }
                            else {
                                this.props.removeMediaFromReport(this.props.roomIndex, this.props.groupIndex, i,file)
                            }
                            this.props.removeMediaFromReport(this.props.roomIndex, this.props.groupIndex, i,file)
                        }
                    };
                    let isItemNotesEmpty = false;
                    if(this.props.reportDetails){
                        if(this.props.reportDetails['inspection_type'] !== 'co' && (item['ci_notes'] == null || item['ci_notes'].length < 2)){
                            isItemNotesEmpty = true;
                        }
                        else if(this.props.reportDetails['inspection_type'] === 'co' && (item['co_notes'] == null || item['co_notes'].length < 2 || !item['flag'] || (item['flag'] == "Tenant Cost" && !item["tenantCostCategory"]))){
                            isItemNotesEmpty = true;
                        }
                    }
                    return <Toggle forceActive={(this.props.items.length -1 === i && isItemNotesEmpty) || this.state.openItems || this.props.forceActive} key={item['client_id']} ref={item['client_id']}
                                   title={<div id={item["client_id"]} className="field" style={{display: 'inline'}}>
                                       {this.state.showEdit === item['client_id'] &&
                                       <div className="ui input report-inputs" style={{width:'655px'}}>
                                           <Form onSubmit={() => {
                                               this.updateItemDetails(this.props.roomIndex, this.props.groupIndex, i, item)
                                           }} style={{width:'100%'}}>
                                               <textarea
                                                      defaultValue={item.name}
                                                      placeholder="Item Name"
                                                      autoFocus
                                                      maxLength="255"
                                                      rows="2"
                                                      onFocus={(e) => {
                                                          this.setState({itemName: e.target.value})
                                                      }}
                                                      onChange={(e) => {
                                                          this.setState({itemName: e.target.value})
                                                      }}
                                                      onBlur={() => {
                                                          if(this.state.itemName.length > 1){
                                                              this.setState({showEdit: undefined});
                                                              this.updateItemDetails(this.props.roomIndex, this.props.groupIndex, i, item)
                                                          }
                                                      }}
                                                      required
                                               />
                                               <div className="right-aligned">
                                               {this.state.itemName && <span className="info-normal">{this.state.itemName.length}/255</span>}
                                               </div>
                                           </Form>
                                       </div>}
                                       {this.state.showEdit !== item['client_id'] &&
                                       <span className="report-field-name" onClick={(e) => {
                                           if (this.props.reportDetails['inspection_type'] !== 'co'|| this.props.reportDetails['inspection_type'] === 'co'&& this.props.other_template) {
                                               this.setState({showEdit: item['client_id']})
                                           }
                                       }}>{item.name}</span>}
                                       {(this.props.reportDetails['inspection_type'] !== 'co' || this.props.reportDetails['inspection_type'] === 'co'&& this.props.other_template )  &&
                                       <div style={{display: 'inline', verticalAlign: 'middle'}} className="pull-right">
                                           <Popup
                                               trigger={<Icon name="trash"
                                                              size='large'
                                                              color='grey'
                                               />}
                                               content={<Button negative content="Confirm Delete Item?"
                                                                onClick={(e) => {
                                                                    this.props.deleteItemFromReport(this.props.roomIndex, this.props.groupIndex, i);
                                                                    this.setState({deleteCalled: !this.state.deleteCalled})
                                                                }}/>}
                                               on="click"
                                               position="right center"
                                               hideOnScroll
                                           />
                                       </div>
                                           }

                                       {isItemNotesEmpty && <div style={{display: 'inline', verticalAlign: 'middle'}} className="pull-right">
                                           <Popup
                                               trigger={<Icon name="warning sign" size="large" color="orange"/>}
                                               content='This Item may not have been updated with Report Notes'
                                               size='mini'
                                           />
                                       </div>}
                                 {this.props.reportDetails.inspection_type === 'co' && !this.props.other_template && item.ci_images && item.ci_images.length > 0 && (
                                <Popup flowing hideOnScroll on="click" position="bottom right" trigger={<Button style={{marginTop:"-5px"}} content={`View CI Images (${item.ci_images.length})`} icon="image" className="pull-right" compact basic />}>
                                    <div style={{ maxWidth: 500, maxHeight: 400, overflowY: 'auto' }}>
                                        <Image.Group size="small">
                                            {item.ci_images.map((img, index) => (
                                                <Image   onClick={() => window.open(img.image_path, '_blank', 'noopener,noreferrer')} key={index} src={img.image_path} bordered rounded style={{ margin: 5, cursor: 'pointer', maxHeight: 150, objectFit: 'cover' }} />
                                            ))}
                                        </Image.Group>
                                    </div>
                                </Popup>
                            )}
                                   </div>}>
                                   {!this.props.overlayImageList &&    <DropzoneComponent key={item['client_id'] + '-' + i}config={componentConfig} eventHandlers={eventHandlers}djsConfig={djsConfig}/>}                 
                        {this.props.overlayImageList && <div style={{textAlign:"center",margin:"10px"}}>
                        {item.images.length > 0 && (
                            <Segment style={{ display: "inline-block", marginBottom: "0px"  }} attached="bottom">
                                <Image.Group size="tiny">
                                {item.images.map(image => {
                                    let image_path = image.image_path || image.image && image.image.file.image_path || image.image && image.image.file.dataURL;
                                    return<Popup key={image.id} trigger={<Image style={{borderRadius:"5px",  width:"auto", height:"100px",
                                    }} src={image_path || unavailable} />}
                                    content={<Button negative content="Confirm Delete Item Image??"  onClick={(e) => { this.removeItemImage(this.props.roomIndex, this.props.groupIndex, i,image); }}/>}  on="click" position="right center" hideOnScroll className="pad-left"/> })} </Image.Group>
                                    </Segment>)}
                                    <ButtonGroup >
                                        <Button icon onClick={()=>{this.previousOverlayImage(10)}}>
                                            <Icon name='fast backward' />
                                        </Button>
                                        <Button icon onClick={()=>{this.previousOverlayImage(1)}}>
                                            <Icon name='caret left' />
                                        </Button>
                                        <Button  disabled={!this.props.overlayImage || (this.props.overlayImage && this.props.overlayImage.loading)} loading={this.props.overlayImage && this.props.overlayImage.loading} onClick={(()=>{this.useOverlayImage(this.props.roomIndex, this.props.groupIndex, i,this.props.overlayImage)})} icon><Icon name="photo"></Icon> Add Selected Overlay Image</Button>
                                        <Button  onClick={()=>{this.nextOverlayImage(1)}}  icon>
                                            <Icon name='caret right' />
                                        </Button>
                                        <Button  onClick={()=>{this.nextOverlayImage(10)}}  icon>
                                            <Icon name='fast forward' />
                                        </Button>
                                        </ButtonGroup>
                        </div>}
                        <Grid columns={2} stackable>

                            <Grid.Row>
                                <Grid.Column width={8}>
                                    <Form onSubmit={() => {
                                        this.updateCheckInNotes(this.props.roomIndex, this.props.groupIndex, i, item)
                                    }}>
                                        <label><b>Check-In Notes</b></label>
                                        <textarea rows='3'
                                                  style={{resize: 'none'}}
                                                  placeholder="Check In Notes"
                                                  disabled={(this.props.reportType === 'co' && !this.props.other_template)}
                                                  defaultValue={item['ci_notes']}
                                                  onFocus={(e) => {
                                                      this.setState({checkInNotes: e.target.value})
                                                  }}
                                                  autoFocus={this.props.reportDetails['inspection_type'] !== 'co' && ((this.props.items.length -1 === i && isItemNotesEmpty && !this.props.forceActive && !this.props.openGroups) || this.state.newItemAdded)}
                                                  onChange={(e) => {
                                                      this.setState({checkInNotes: e.target.value?e.target.value:" "});
                                                  }}
                                                  onBlur={() => {
                                                      this.setState({newItemAdded:false});
                                                      this.updateCheckInNotes(this.props.roomIndex, this.props.groupIndex, i, item)
                                                  }}
                                        />
                                    </Form>
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <Form onSubmit={() => {
                                        this.updateCheckOutNotes(this.props.roomIndex, this.props.groupIndex, i, item)
                                    }}>
                                        <label><b>Check-Out Notes</b></label>
                                         <textarea rows='3'
                                                  style={{resize: 'none'}}
                                                  placeholder="Check Out Notes"
                                                  disabled={this.props.reportType !== 'co'}
                                                  defaultValue={item['co_notes']}
                                                  onFocus={(e) => {
                                                      this.setState({checkOutNotes: e.target.value})
                                                  }}
                                                  autoFocus={this.props.reportDetails['inspection_type'] === 'co'  && ((this.props.items.length -1 === i && isItemNotesEmpty && !this.state.forceActive && !this.props.forceActive && !this.props.openGroups) || this.state.newItemAdded)}
                                                  onChange={(e) => {
                                                      this.setState({checkOutNotes: e.target.value?e.target.value:" "});
                                                  }}
                                                  onBlur={() => {
                                                      this.setState({newItemAdded:false});
                                                      this.updateCheckOutNotes(this.props.roomIndex, this.props.groupIndex, i, item)
                                                      this.setState({checkOutNotes:""})
                                                  }}

                                                    onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                    e.preventDefault();
                                                    e.target.blur();
                                                  const dropdown = document.getElementById(`liability-dropdown-${item["client_id"]}`);
                                                    if (dropdown) {
                                                        setTimeout(() => {
                                                            dropdown.click();
                                                        }, 100); // 100 ms delay
                                                    }
                                                }}}
                                        />
                                        <div className="pad-top">
                                            <Form.Dropdown
                                                id={`liability-dropdown-${item["client_id"]}`}
                                                label='Liability Type'
                                                required
                                                selection
                                                disabled={this.props.reportType !== 'co' || (item['co_notes']== "" || item['co_notes']== " " && this.state.checkOutNotes == "" || this.state.checkOutNotes == " ") || (item['co_notes'] == null && this.state.checkOutNotes == "" || this.state.checkOutNotes == " ")}
                                                upward
                                                wrapSelection={true}
                                                options={checkoutNoteFlag}
                                                placeholder='None (Show as Checkmark)'
                                                value={item['flag']}
                                                onChange={async (e, option) => {
                                                    this.updateCheckOutNotes(this.props.roomIndex, this.props.groupIndex, i, item,option.value);
                                                      setTimeout(() => {
                                                        const dropdown = document.getElementById(`cat-liability-dropdown-${item["client_id"]}`);
                                                        if (dropdown) {
                                                            // Inner delay: wait before clicking
                                                            setTimeout(() => {
                                                            dropdown.click();
                                                            }, 100);
                                                        }
                                                        }, 100);
                                                }}
                                            />
                                        </div>
                                        {item && item['co_notes'] && item['flag'] && item['flag'] == "Tenant Cost" && <div className="pad-top">
                                            <Form.Dropdown
                                            id={`cat-liability-dropdown-${item["client_id"]}`}
                                                label='Tenant Cost Category'
                                                selection
                                                required
                                                disabled={this.props.reportType !== 'co' || (item['co_notes']== "" || item['co_notes']== " " && this.state.checkOutNotes == "" || this.state.checkOutNotes == " ") || (item['co_notes'] == null && this.state.checkOutNotes == "" || this.state.checkOutNotes == " ")}
                                                upward
                                                wrapSelection={true}
                                                options={tenantCostCategories}
                                                placeholder='None'
                                                value={item["tenant_cost_category"]}
                                                onChange={async (e, option) => {
                                                    this.updateCheckOutNotes(this.props.roomIndex, this.props.groupIndex, i, item,undefined,undefined,option.value)
                                                }}
                                            />
                                        </div>}
                                        {item && item['co_notes'] && item['flag'] && item['flag'] != "None" && <div className="center-aligned pad-top">
                                            {this.state.showCoAdd !== item['client_id'] && <div className="pad-top"><Button   compact size="mini" onClick={()=>{this.setState({showCoAdd:item['client_id'],additionalCoNoteFlag:"Wear and Tear", additionalCoNoteTenantCostCategory:undefined})}}
                                         >+ Add Note</Button></div>}
                                         {this.state.showCoAdd === item['client_id'] && <Segment><div style={{minWidth:'300px'}} className="pad-top pad-bottom">
                                                    <Form onSubmit={(e) => {this.setState({showCoAdd:undefined},this.updateCheckOutNotes(this.props.roomIndex, this.props.groupIndex, i, item,undefined,e));}}>                                    
                                                        <Form.TextArea rows='3'
                                                                  style={{resize: 'none'}}
                                                                  placeholder="Additional Check Out Notes"
                                                                  name="co_desc_text"
                                                                  required
                                                                  className="pad-bottom"
                                                                  label="Additional Check Out Note"
                                                        />
                                                        <div className="pad-top pad-bottom">
                                                            <Form.Dropdown
                                                                label='Note Type'
                                                                required
                                                                selection
                                                                upward
                                                                wrapSelection={true}
                                                                options={checkoutNoteFlag}
                                                                placeholder='Mark Note As'
                                                                defaultValue={this.state.additionalCoNoteFlag? this.state.additionalCoNoteFlag :"Wear and Tear"}
                                                                onChange={(e,{value})=>{this.setState({additionalCoNoteFlag:value})}}
                                                            />
                                                        </div>

                                                        {this.state.additionalCoNoteFlag == "Tenant Cost" && <div className="pad-top pad-bottom">
                                                            <Form.Dropdown
                                                                label='Tenant Cost Category'
                                                                required
                                                                selection
                                                                upward
                                                                wrapSelection={true}
                                                                options={tenantCostCategories}
                                                                placeholder='Mark Note As'
                                                                defaultValue="Wear and Tear"
                                                                onChange={(e, { value }) => { this.setState({ additionalCoNoteTenantCostCategory: value }) }}
                                                            />
                                                        </div>}
                                                        <div className="right-aligned pad-top">
                                                            <Button type="button" content="Cancel" onClick={()=>{this.setState({showCoAdd:undefined})}}/>
                                                            <Button type="submit" content="Add now" primary/>
                                                        </div>
                                                    </Form>
                                                </div></Segment>}
                                        </div>}
                                    </Form>
                                </Grid.Column>
                            </Grid.Row>
                            {!item['flag']  && this.props.reportType == 'co' && <Grid.Row>
                                <Grid.Column width={16}>
                             <div style={{textAlign:"center"}}>
                                    <Header as="h4">Quick Assign Liability</Header>
                                                
                                            <Button compact onClick={()=> this.updateCheckOutNotes(this.props.roomIndex, this.props.groupIndex, i, item,"Tenant Cost")}>Tenant Cost</Button>
                                            <Button compact onClick={()=> this.updateCheckOutNotes(this.props.roomIndex, this.props.groupIndex, i, item,"Wear and Tear")}>Fair Wear and Tear</Button>
                                            <Button compact onClick={()=> this.updateCheckOutNotes(this.props.roomIndex, this.props.groupIndex, i, item,"Landlord Info")}>Landlord Information</Button>
                                        {this.props.other_template && <Button compact onClick={()=>{ this.updateCheckOutNotes(this.props.roomIndex, this.props.groupIndex, i, item,"Similar")}}>Similar to Check In</Button>}</div></Grid.Column>
                            </Grid.Row>}
                                {item['flag'] == "Tenant Cost" && !item['tenant_cost_category'] && this.props.reportType == 'co' && <Grid.Row>
                                <Grid.Column width={16}>
                                    <div style={{textAlign:"center"}}>
                                        <Header as="h4">Quick Assign Tenant Cost Liability Category</Header>
                                        <Button compact onClick={()=> this.updateCheckOutNotes(this.props.roomIndex, this.props.groupIndex, i, item, null,null,"CLEANING")}>CLEANING</Button>
                                        <Button compact onClick={()=> this.updateCheckOutNotes(this.props.roomIndex, this.props.groupIndex, i, item, null,null,"DAMAGE")}>DAMAGE</Button>
                                        <Button compact onClick={()=> this.updateCheckOutNotes(this.props.roomIndex, this.props.groupIndex, i, item, null,null,"REDECORATION")}>REDECORATION</Button>                                        
                                        <Button compact onClick={()=> this.updateCheckOutNotes(this.props.roomIndex, this.props.groupIndex, i, item, null,null,"GARDENING")}>GARDENING</Button>
                                        <Button compact onClick={()=> this.updateCheckOutNotes(this.props.roomIndex, this.props.groupIndex, i, item, null,null,"OTHER")}>OTHER</Button>
                                                
                                </div></Grid.Column>
                            </Grid.Row>}
                            {item && item['additional_co_notes'] && item['additional_co_notes'].length > 0 && item['additional_co_notes'] &&  <Grid.Row>
                                <Grid.Column width={8}>
                                </Grid.Column>
                                <Grid.Column width={8}>
                                    <Header size="small" content="Additional CO Notes" textAlign="center"/>
                                    {item && item['additional_co_notes'] && item['additional_co_notes'].map((aco,aci)=>{

                                        return(
                                            aco['action'] !== 'delete' && <div key={aci} className="pad-all format-capitalize show-action-hover">
                                                {<div style={{display: 'inline', verticalAlign: 'middle'}} className="delete-action">
                                                    <Popup
                                                        trigger={<Icon name="trash"
                                                                       size='large'
                                                                       color='red'
                                                                       className="icon-button"
                                                        />}
                                                        content={<Button negative content="Confirm Delete Note?"
                                                                         onClick={(e) => {
                                                                             this.handleAdditionalCODelete(this.props.roomIndex, this.props.groupIndex, i, item,aci);
                                                                         }}/>}
                                                        on="click"
                                                        position="left center"
                                                        hideOnScroll
                                                    />
                                                </div>}
                                                {aco['co_notes']?aco['co_notes']:""} <span className="format-bold">{aco['flag']?<Button basic color="grey" compact size="mini">{aco['flag']}</Button>:"NA"}{aco['flag'] == "Tenant Cost" && <Button basic color="orange" compact size="mini">{aco["tenant_cost_category"] ? `${aco["tenant_cost_category"]}` : "OTHER"  }</Button>} </span></div>
                                        )
                                    })}
                                </Grid.Column>
                            </Grid.Row>}
                        </Grid>
                    </Toggle>
                }) : null}
            </CollapsiblePanel>
            <AddNewDataToReport type='Item' reportId={this.props.reportId} other_template={this.props.other_template} roomId={this.props.roomId}
                                groupId={this.props.groupId} roomIndex={this.props.roomIndex}
                                groupIndex={this.props.groupIndex} newItemAdded={(value) => {this.setState({newItemAdded:value})}}/>
        </div>);
    }
}

export default ReportContainer(ItemsListView);


// WEBPACK FOOTER //
// ./src/views/report/items_list.js